export const router = [
  {
    path: "test",
    redirect: "/test/iconTest",
    component: (resolve) => require(["./layout/Index.vue"], resolve),
    children: [
      {
        path: "iconTest",
        component: (resolve) => require(["./iconTest/Index.vue"], resolve),
      },
      {
        path: "componentsTest",
        component: (resolve) =>
          require(["./componentsTest/Index.vue"], resolve),
      },
    ],
  },
];
